export const langVi = {
  thaydoithongtin: 'Cập nhật thông tin',
  builongchonnoicap: 'Vui lòng chọn nơi cấp',
  ngayhethan: 'Ngày hết hạn',
  hinhanhcccd: 'Hình ảnh CCCD',
  capnhatcmndcccdthanhcong: `Thông tin thay đổi của Quý khách sẽ được LightHouse Capital phê duyệt trong thời gian quy định.\nTrong thời gian này, Quý khách vui lòng không thực hiện thay đổi thông tin khác.`,
  gioihan12so: 'Số CCCD không hợp lệ',
  thongtinkhongduocdetrong: 'Thông tin không được để trống',
  vuilongtaianh: `Vui lòng tải ảnh giấy tờ CCCD của bạn.`,
  giaytobatbuocnhap: `Số hiệu giấy tờ bắt buộc nhập.`,
  ngaycapbatbuocnhap: `Ngày cấp không hợp lệ.`,
  trangthaihoso: 'Trạng thái hồ sơ',
  PENDING: 'Chờ phê duyệt',
  REJECT: 'Từ chối',
  PENDING_note: `Thông tin thay đổi của Quý khách sẽ được LightHouse Capital phê duyệt trong thời gian quy định.\n\nTrong thời gian này, Quý khách vui lòng không thực hiện thay đổi thông tin khác.`,
  REJECT_note: `Cung cấp lý do từ chối thông tin khách hàng cung cấp.`,
  signcontent: `Quý khách có thể ký trực tiếp trên màn hình hoặc tải hình ảnh có sẳn chữ ký`,
  lydotuchoi: 'Lý do từ chối',
};

export const langEn = {
  thaydoithongtin: 'Update information',
  builongchonnoicap: 'Please select place of issue',
  ngayhethan: 'Expire date',
  hinhanhcccd: 'Photos of ID',
  capnhatcmndcccdthanhcong: `Your updated information will be reviewed by LightHouse Capital within the specified timeframe.
  
During this period, please do not make any changes to your information.`,
  gioihan12so: 'Your Identity Card No is invalid',
  thongtinkhongduocdetrong: 'This field is required',
  vuilongtaianh: `Please upload a photo of your ID card.`,
  giaytobatbuocnhap: `Document no is mandatory.`,
  ngaycapbatbuocnhap: `Issued date is invalid.`,
  trangthaihoso: 'Application status',
  PENDING: 'Pending Approval',
  REJECT: 'Reject',
  PENDING_note: `Your updated information will be reviewed by LightHouse Capital within the specified timeframe.\nDuring this period, please do not make any changes to your information.`,
  REJECT_note: `Cung cấp lý do từ chối thông tin khách hàng cung cấp.`,
  signcontent: `You can sign directly on the screen or upload an image with the signature`,
  lydotuchoi: 'Reject reason',
};
